import { BASE_ROUTE } from "@/common/constants";
import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

const RELOAD_FLAG_KEY = "app-boundary-reload-attempted";

/**
 * Detects when the browser URL leaves the /hardware boundary (e.g. via
 * back/forward navigation) and forces a full page reload so CloudFront
 * can route the request to the correct SPA.
 */
export const AppBoundaryReloadGuard: FC = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const browserPath = window.location.pathname;
    const belongsToAppBoundary = browserPath.startsWith(BASE_ROUTE);

    if (belongsToAppBoundary) {
      sessionStorage.removeItem(RELOAD_FLAG_KEY);
      return;
    }

    if (!sessionStorage.getItem(RELOAD_FLAG_KEY)) {
      sessionStorage.setItem(RELOAD_FLAG_KEY, "true");
      window.location.replace(
        `${browserPath}${window.location.search}${window.location.hash}`
      );
    }
  }, [pathname, search, hash]);

  return null;
};
